import { render, staticRenderFns } from "./BulkProductExport.vue?vue&type=template&id=5b22cf3f"
import script from "./BulkProductExport.vue?vue&type=script&lang=js"
export * from "./BulkProductExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports